export function ErrorState({ message }: { message: string }): JSX.Element {
  return (
    <div className="animate-fade-in rounded-xl border border-red-200 bg-red-50 p-6 text-center dark:border-red-900/60 dark:bg-red-950/40">
      <p className="text-sm font-medium text-red-800 dark:text-red-300">Something went wrong</p>
      <p className="mt-1 text-sm text-red-600 dark:text-red-400">{message}</p>
    </div>
  );
}
